import { Blockchain } from '@verisart/nft/src/common'

export const getGasLimit = (blockchain: Blockchain, standardLimit: bigint) => {
  if (
    blockchain === Blockchain.ETHEREUM ||
    blockchain === Blockchain.FAKE_ETHEREUM_ON_SEPOLIA
  ) {
    return standardLimit
  }
  return undefined
}
